module.exports = __webpack_public_path__ + "media/images/header-51a6c17f38b06b0d4d300a84e88487e1.jpg";